// extracted by mini-css-extract-plugin
export default {"btn":"LearnMoreBtn_btn__sWbKN","icon":"LearnMoreBtn_icon__jcpmr","redbtn":"LearnMoreBtn_redbtn__4+CoY","orangebtn":"LearnMoreBtn_orangebtn__3U5gu"};